"use client";
import { Form } from "react-bootstrap";
import "../style/style-register.css";
import { useEffect, useState } from "react";
import axios from "../axios/axios";
import Cookies from "js-cookie";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";

export default function ReinitialiserPassWord() {
  const [email, setEmail] = useState("");
  const [nouvelPassword, setNouvelPassword] = useState("");
  const [confirmeNouvelPassword, setConfirmeNouvelPassword] = useState("");
  const [success, setSuccess] = useState(null);
  const [error, setError] = useState(null);

  const navigate = useNavigate();
  const { token } = useParams();

  const setAuthToken = (token) => {
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  };

  useEffect(() => {
    getToken();
  }, []);

  const getToken = () => {
    axios
      .get(`/getToken/${token}`, {
        headers: {
          Accept: "application/json",
        },
      })
      .then((response) => {
        setEmail(response.data.user.email);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const reinitialiserPass = (e) => {
    e.preventDefault();

    Swal.fire({
      title: "Traitement en cours, veuillez patienter ...",
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    if (nouvelPassword != confirmeNouvelPassword) {
      setError("Confirmer mot de passe");
      Swal.close();
      return 0;
    } else {
      const form = new FormData();
      form.append("email", email);
      form.append("password", nouvelPassword);
      form.append("token", token);

      axios
        .post("/reinitialiserPassWord", form, {
          headers: {
            Accept: "application/json",
          },
        })
        .then((response) => {
          setSuccess(response.data.success);
          setError(response.data.error);
          if (response.data.user != null) {
            const { user } = response.data;
            const { access_token } = response.data;

            setAuthToken(access_token);
            Cookies.set("auth_token", access_token);
            Cookies.set("auth_user", JSON.stringify(user));

            setError(null);

            if (response.data.user.role == 1) {
              navigate(`${process.env.PUBLIC_URL}/rim`);
            } else {
              // Récupérer l'URL de redirection
              const redirectUrl =
                Cookies.get("redirect_url") ||
                `${process.env.PUBLIC_URL}/profile`;
              // Supprimer l'URL de redirection des cookies
              Cookies.remove("redirect_url");
              // Rediriger vers l'URL de redirection
              navigate(redirectUrl);
            }
          }
          Swal.close();
        })
        .catch((err) => {
          console.log(err);
          Swal.close();
        });
    }
  };

  return (
    <div id="section" className="signup">
      <div className="container card">
        <div className="row bg-light">
          <div className="col-sm-12">
            <center>
              <h4 style={{ fontWeight: "900", padding: "10px" }}>
                Réinitialiser le mot de passe
              </h4>
            </center>
          </div>
        </div>

        <div className="signup-content">
          <Form
            id="signup-form"
            className="signup-form"
            onSubmit={reinitialiserPass}
          >
            <div className="row">
              {success != null ? (
                <div className="alert alert-success col-sm-12 text-center">
                  {" "}
                  {success}{" "}
                </div>
              ) : null}

              <div className="form-group col-sm-12">
                <label>Email</label>
                <input
                  type="email"
                  required
                  className="form-input"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    setError(null);
                  }}
                />
              </div>

              <div className="form-group col-sm-12">
                <label>Nouveau Mot de passe</label>
                <input
                  type="password"
                  required
                  className="form-input"
                  value={nouvelPassword}
                  onChange={(e) => {
                    setNouvelPassword(e.target.value);
                    setError(null);
                  }}
                />
              </div>

              <div className="form-group col-sm-12">
                <label>Confirmer le nouveau mot de passe</label>
                <input
                  type="password"
                  required
                  className="form-input"
                  value={confirmeNouvelPassword}
                  onChange={(e) => {
                    setConfirmeNouvelPassword(e.target.value);
                    setError(null);
                  }}
                />
                {error != null ? (
                  <div className="alert alert-danger col-sm-12 text-center">
                    {" "}
                    {error}{" "}
                  </div>
                ) : null}
              </div>

              <div className="form-group col-sm-12 ">
                <button
                  type="submit"
                  className="btn "
                  style={{
                    borderRadius: "25px",
                    float: "right",
                    fontWeight: "900",
                    background: "#047104",
                    color: "#fff",
                  }}
                >
                  Réinitialiser votre mot de passe
                </button>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
}
